<template>
  <div>
    <el-menu class="el-menu-top" mode="horizontal">
      <el-cascader
        :options="projects"
        v-model="selectedProject"
        @change="handleChange"
        placeholder="Choose project"
        popper-class="projects-list"
        filterable
      >
      </el-cascader>
      <div class="dropdown-container">
        <el-submenu index="1" class="dropdown__user" placement="bottom">
          <template slot="title">
            <i class="far fa-user-circle"></i>Bartłomiej
          </template>
          <el-menu-item index="1-1">Account</el-menu-item>
          <el-menu-item index="1-2">Settings</el-menu-item>
          <el-menu-item index="1-3">Logout</el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'TopBar',
  props: ['reset'],
  data: () => ({
    selectedProject: [],
    projects: [
      {
        value: '1',
        label: 'Test project #1',
      },
      {
        value: '2',
        label: 'Test project #2',
      },
    ],
  }),
  watch: {
    reset(val) {
      if (val) {
        this.selectedProject = [];
      }
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('projectChange', value[0]);
    },
  },
};
</script>
<style lang="scss">
$mainColor: #00D457;
$fontColor: #aaaaaa;

.el-menu-top {
  width: calc(100% - 50px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: $fontColor;
  height: 70px;
  padding-left: 50px !important;

  .dropdown-container {
    position: absolute;
    margin: 0 35px;
    right: 0;
    height: 100%;
  }

  .el-submenu {
    height: 100%;
  }

  .el-submenu__title {
    height: 100%;
    padding: 0 50px 0 10px;
    color: $fontColor;
    font-family: 'Quicksand', sans-serif;
    font-size: 1.6rem;
    font-weight: 500;
    letter-spacing: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    i {
      color: $fontColor;
      font-size: 1.8rem;
    }

    i.far {
      font-size: 2.4rem;
      padding: 0 10px;
      position: relative;
      top: -1px;
    }

    i.far.fa-user-circle {
      position: relative;
      top: 1px;
    }
  }

  .el-cascader {
    width: 100%;
    max-width: 300px;
  }
}

.projects-list {
  width: 300px;

  .el-cascader-menu {
    width: 100%;
    height: auto;
    &__item {
      font-family: 'Quicksand', sans-serif;
    }
  }
}

.el-menu--popup > .el-menu-item {
  font-family: 'Quicksand', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue